<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<!--input类型示例-->
		<FormItem prop="ConponName">
			<Input style="width: 260px;" type="text" v-model="formInline.ConponName" :placeholder="$tt('优惠券名字')">
			<span slot="prepend">{{$tt('优惠券名字')}}</span>
			</Input>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')">{{$tt('查询')}}</Button>
		</FormItem>
		<!-- <FormItem>
			<Button type="primary" @click="$emit('exportFile')">{{$tt('导出文件')}}</Button>
		</FormItem> -->
		<div style="float: right;margin-left: 0.15625rem;">
			<Button type="success" @click="$emit('show','add1')" v-if="hasWidgets('add')">{{$tt('新增满减券')}}</Button>
		</div>
		<div style="float: right;margin-left: 0.15625rem;">
			<Button type="success" @click="$emit('show','add2')" v-if="hasWidgets('add')">{{$tt('新增折扣券')}}</Button>
		</div>
		<div style="float: right;margin-left: 0.15625rem;">
			<Button type="success" @click="$emit('show','add3')" v-if="hasWidgets('add')">{{$tt('新增随机立减券')}}</Button>
		</div>
	</Form>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					ConponName: ''
				},
			};
		},
		computed: {
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
		},
	}
</script>

<style>
</style>
